import React from "react";
import {OrderEditorTabProps} from "@widgets/pos/order/OrderEditor";
import {InputLabel, TextField} from "peggirkit";
import {FormattedMessage, useIntl} from "react-intl";
import {emptyToNull, getInputValidationProps} from "@/data/Validation";
import {orderPersonValidation, PosOrderForm} from "@/data/entities/order";
import {useFormContext} from "react-hook-form";


const GuestPersonalInformation = ({isPending}: OrderEditorTabProps) => {
    const intl = useIntl();
    const {register, formState: {errors}} = useFormContext<PosOrderForm>();

    return (
        <div className={"w-full grid grid-cols-2 gap-4"}>
            <TextField
                type={"text"}
                label={
                    <InputLabel hint={<FormattedMessage id={"required"}/>}>
                        <FormattedMessage id={"firstName"}/>
                    </InputLabel>
                }
                disabled={isPending}
                error={errors.contactDetails?.firstName && errors.contactDetails.firstName.message}
                {...register("contactDetails.firstName", {
                    ...getInputValidationProps(orderPersonValidation.firstName, intl),
                })}
            />

            <TextField
                type={"text"}
                label={
                    <InputLabel hint={<FormattedMessage id={"required"}/>}>
                        <FormattedMessage id={"lastName"}/>
                    </InputLabel>
                }
                disabled={isPending}
                error={errors.contactDetails?.lastName && errors.contactDetails.lastName.message}
                {...register("contactDetails.lastName", {
                    ...getInputValidationProps(orderPersonValidation.lastName, intl),
                })}
            />

            <TextField
                type={"email"}
                autoComplete={"off"}
                label={
                    <InputLabel hint={<FormattedMessage id={"optional"}/>}>
                        <FormattedMessage id={"emailAddress"}/>
                    </InputLabel>
                }
                disabled={isPending}
                error={errors.contactDetails?.emailAddress && errors.contactDetails.emailAddress.message}
                {...register("contactDetails.emailAddress", {
                    ...getInputValidationProps(orderPersonValidation.emailAddress, intl),
                    setValueAs: emptyToNull,
                })}
            />

            <TextField
                type={"text"}
                label={
                    <InputLabel hint={<FormattedMessage id={"optional"}/>}>
                        <FormattedMessage id={"phoneNumber"}/>
                    </InputLabel>
                }
                disabled={isPending}
                error={errors.contactDetails?.phoneNumber && errors.contactDetails.phoneNumber.message}
                {...register("contactDetails.phoneNumber", {
                    ...getInputValidationProps(orderPersonValidation.phoneNumber, intl),
                    setValueAs: emptyToNull,
                })}
            />
        </div>
    );
};

export default GuestPersonalInformation;